var data = [];
var data_indexes = {};
var max_value = 110;

$(document).on("turbolinks:load", () => {
    $('.village-profile-select').on('change', function() {
        $div_id = this.id
        $div_index = parseInt($div_id[$div_id.length -1]) - 1
        $.ajax({
            type: "GET",
            url: "get_village_for_profile?id="+this.value+"&index="+$div_index,
            success: function(response) {
              infos = showOnGraph(response, $div_index)
            }
        });
    });
});

function showOnGraph(village_infos, select_index) {
    data_index = data_indexes[select_index];
    if(data_index !== undefined) {
        data[data_index] = village_infos;
    } else {
        data_index = data.push(village_infos) - 1;
        data_indexes[select_index] = data_index;
    }
    update_max_value();
    createChart(data);
}

function update_max_value() {
    max = 0
    for(var i=0; i<data.length; i++) {
        data_max = Math.max.apply(Math,data[i]["data"]);
        if(data_max > max) {
            max = data_max;
        }
    }
    max_value = max;
}

function createChart(data) {
    Highcharts.chart('spider-chart-container', {

        chart: {
            polar: true,
            type: 'line'
        },
    
        title: {
            text: 'Villages Profiles Comparison',
            x: -80
        },
    
        pane: {
            size: '80%'
        },
    
        xAxis: {
            categories: ['Members', 'Volunteers', 'Services Provided', 'Events',
                'Events Attendance', 'MailChimp Sent', 'MailChimp Opened',
                'Newsletters', 'Donations', 'Payments', 'Hours', 'Providers', 'Prospect Tasks'],
            tickmarkPlacement: 'on',
            lineWidth: 0
        },
    
        yAxis: {
            gridLineInterpolation: 'polygon',
            lineWidth: 0,
            min: 0,
            max: max_value
        },
    
        tooltip: {
            shared: true,
            pointFormat: '<span style="color:{series.color}">{series.name}: <b>{point.y:,.0f}</b><br/>'
        },
    
        legend: {
            align: 'right',
            verticalAlign: 'middle',
            layout: 'vertical'
        },
    
        series: data,
    
        responsive: {
            rules: [{
                condition: {
                    maxWidth: 500
                },
                chartOptions: {
                    legend: {
                        align: 'center',
                        verticalAlign: 'bottom',
                        layout: 'horizontal'
                    },
                    pane: {
                        size: '80%'
                    }
                }
            }]
        }
    
    });
}